import React from 'react';
import PropTypes from 'prop-types';
import { NavItem } from './navItem';

export const NavItems = ({
  items, computeTitleFor, computeOnClickFor,
}) => {
  return (
    <>
      {items.map(item => {
        const childItems = item?.attr('children')?.resources()?.list() ?? [];
        return (
          <NavItem
            key={item.id()}
            title={computeTitleFor(item)}
            onClick={computeOnClickFor(item)}
            expandedByDefault={item.isTruthy('expandedByDefault')}
            disabled={item.isTruthy('disabled')}
            canExpand={childItems.length > 0}
          >
            <NavItems
              items={childItems}
              computeOnClickFor={computeOnClickFor}
              computeTitleFor={computeTitleFor}
            />
          </NavItem>
        );
      })}
    </>
  );
};

NavItems.propTypes = {
  items: PropTypes.array.isRequired,
  computeTitleFor: PropTypes.func.isRequired,
  computeOnClickFor: PropTypes.func.isRequired,
};
